import React, { useEffect, useMemo, useState } from "react";
import FreeFireimg from "../../assets/img/budahazr.png";

const API_PRODUCTS =
"https://ffqadir.az/backendtest_9/api/freeFire";

const API_SUBMIT =
"https://ffqadir.az/backendtest_9/api/freeFireCat/addinvoice";

const API_KART =
"https://ffqadir.az/backendtest_9/api/kart";

const FreeFire = () => {
// =========================================================
// STATE
// =========================================================

const [products, setProducts] = useState([]);
const [selectedProducts, setSelectedProducts] = useState([]);

const [loading, setLoading] = useState(true);
const [productError, setProductError] = useState("");

const [kartInfo, setKartInfo] = useState(
"Kart məlumatı yüklənir..."
);

const [isModalOpen, setIsModalOpen] = useState(false);

const [count, setCount] = useState(1);
const [userId, setUserId] = useState("");

const [photoFile, setPhotoFile] = useState(null);
const [uploadStatus, setUploadStatus] =
useState("Fayl seçilməyib");

const [submitting, setSubmitting] = useState(false);

// =========================================================
// MƏHSULLARI GƏTİR
// =========================================================

const getProducts = async () => {
try {
setLoading(true);
setProductError("");

  const response = await fetch(API_PRODUCTS);

  if (!response.ok) {
    throw new Error("Məhsullar yüklənmədi");
  }

  const data = await response.json();

  if (!Array.isArray(data)) {
    setProducts([]);
    return;
  }

  const sortedProducts = [...data].sort(
    (a, b) =>
      parseFloat(a?.price || 0) -
      parseFloat(b?.price || 0)
  );

  setProducts(sortedProducts);
} catch (error) {
  console.error("Məhsul xətası:", error);

  setProductError(
    "Məhsulları yükləyərkən xəta baş verdi."
  );
} finally {
  setLoading(false);
}

};

// =========================================================
// KART MƏLUMATINI GƏTİR
// =========================================================

const getKartInfo = async () => {
try {
setKartInfo("Kart məlumatı yüklənir...");

  const response = await fetch(API_KART);

  if (!response.ok) {
    throw new Error(
      `Kart API HTTP ${response.status}`
    );
  }

  const data = await response.json();

  const kartTitle =
    data?.allKart?.[0]?.title;

  setKartInfo(
    kartTitle || "Kart məlumatı tapılmadı"
  );
} catch (error) {
  console.error(
    "Kart məlumatı yüklənmədi:",
    error
  );

  setKartInfo("Kart məlumatı yüklənmədi");
}

};

// =========================================================
// INITIAL
// =========================================================

useEffect(() => {
getProducts();
getKartInfo();
}, []);

// =========================================================
// FREEFIRE / AYLIQ AYIR
// =========================================================

const almazProducts = useMemo(() => {
return products.filter((item) =>
/almaz/i.test(String(item?.title || ""))
);
}, [products]);

const monthlyProducts = useMemo(() => {
return products.filter(
(item) =>
!/almaz/i.test(String(item?.title || ""))
);
}, [products]);

// =========================================================
// SEÇİLƏN SAY
// =========================================================

const selectedCount = selectedProducts.length;

// =========================================================
// ÜMUMİ QİYMƏT
// =========================================================

const unitTotal = useMemo(() => {
return selectedProducts.reduce(
(total, product) =>
total + Number(product.price || 0),
0
);
}, [selectedProducts]);

const finalTotal =
unitTotal *
Math.max(Number(count) || 1, 1);

// =========================================================
// MƏHSUL SEÇ / SEÇİMDƏN ÇIXAR
// =========================================================

const toggleProductSelection = (product) => {
const productId = String(product?._id);

setSelectedProducts((prev) => {
  const alreadySelected = prev.some(
    (item) => String(item._id) === productId
  );

  if (alreadySelected) {
    return prev.filter(
      (item) =>
        String(item._id) !== productId
    );
  }

  return [
    ...prev,
    {
      ...product,
      price: Number(product.price || 0),
    },
  ];
});

};

// =========================================================
// MODAL AÇ
// =========================================================

const openMultiModal = () => {
if (selectedProducts.length === 0) {
window.alert(
"Zəhmət olmasa ən azı 1 paket seçin!"
);
return;
}

setCount(1);
setUserId("");
setPhotoFile(null);
setUploadStatus("Fayl seçilməyib");

setIsModalOpen(true);

};

// =========================================================
// MODAL BAĞLA
// =========================================================

const closeModal = () => {
if (submitting) return;

setIsModalOpen(false);
setUserId("");
setCount(1);
setPhotoFile(null);
setUploadStatus("Fayl seçilməyib");

};

// =========================================================
// ESC İLƏ BAĞLA
// =========================================================

useEffect(() => {
const handleKeyDown = (event) => {
if (
event.key === "Escape" &&
isModalOpen &&
!submitting
) {
closeModal();
}
};

document.addEventListener(
  "keydown",
  handleKeyDown
);

return () => {
  document.removeEventListener(
    "keydown",
    handleKeyDown
  );
};

}, [isModalOpen, submitting]);

// =========================================================
// MODAL AÇIQ OLANDA BODY SCROLL BAĞLA
// =========================================================

useEffect(() => {
if (isModalOpen) {
document.body.style.overflow = "hidden";
} else {
document.body.style.overflow = "";
}

return () => {
  document.body.style.overflow = "";
};

}, [isModalOpen]);

// =========================================================
// FOTO SEÇİMİ
// =========================================================

const handlePhotoChange = (event) => {
const file = event.target.files?.[0];

if (!file) {
  setPhotoFile(null);
  setUploadStatus("Fayl seçilməyib");
  return;
}

setPhotoFile(file);
setUploadStatus(`✅ ${file.name}`);

};

// =========================================================
// SİFARİŞ GÖNDƏR
// =========================================================

const handleSubmit = async (event) => {
event.preventDefault();

if (selectedProducts.length === 0) {
  window.alert(
    "Zəhmət olmasa ən azı 1 paket seçin!"
  );
  return;
}

if (!userId.trim()) {
  window.alert(
    "Zəhmət olmasa FreeFire User ID daxil edin!"
  );
  return;
}

if (!photoFile) {
  window.alert(
    "Zəhmət olmasa ödəniş qəbzini yükləyin!"
  );
  return;
}

try {
  setSubmitting(true);

  const formData = new FormData();

  const names = selectedProducts
    .map((product) => product.title)
    .join(" + ");

  formData.append("title", names);

  formData.append(
    "price",
    `${finalTotal.toFixed(2)} AZN`
  );

  formData.append(
    "count",
    String(
      Math.max(Number(count) || 1, 1)
    )
  );

  formData.append(
    "description",
    `${selectedProducts.length} paket seçildi`
  );

  formData.append(
    "pubgId",
    userId.trim()
  );

  formData.append(
    "photo",
    photoFile
  );

  const response = await fetch(API_SUBMIT, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error(
      "Sifariş göndərilə bilmədi"
    );
  }

  window.alert(
    "Sifarişiniz uğurla qəbul olundu!\n\n" +
    "⏱ Yüklənmə müddəti: 1–10 dəq.\n\n" +
    "‼️ Qeyd: Balansın görünməsi üçün oyuna yenidən daxil olun."
  );

  setIsModalOpen(false);

  setSelectedProducts([]);
  setCount(1);
  setUserId("");
  setPhotoFile(null);
  setUploadStatus("Fayl seçilməyib");

  await getProducts();
} catch (error) {
  console.error(
    "Sifariş göndərmə xətası:",
    error
  );

  window.alert(
    "Xəta baş verdi. Canlı dəstək vasitəsilə əlaqə saxlayın."
  );
} finally {
  setSubmitting(false);
}

};

// =========================================================
// MƏHSUL SƏTRİ
// =========================================================

const renderProductRow = (
item,
index,
globalIndex
) => {
const productId = String(item?._id);

const isSelected = selectedProducts.some(
  (selected) =>
    String(selected?._id) === productId
);

return (
  <tr
    key={productId}
    onClick={() =>
      toggleProductSelection(item)
    }
    className={`
      group
      cursor-pointer
      border-b
      border-[#231842]/70
      transition-all
      duration-200

      ${
        isSelected
          ? `
            bg-gradient-to-r
            from-[#FFB800]/[0.13]
            via-[#8B5CF6]/[0.09]
            to-transparent
            shadow-[inset_3px_0_0_#FFB800]
          `
          : `
            bg-[#080510]/70
            hover:bg-gradient-to-r
            hover:from-[#FFB800]/[0.055]
            hover:via-[#8B5CF6]/[0.045]
            hover:to-transparent
          `
      }
    `}
  >
    {/* =================================================
        #
    ================================================== */}

    <td
      className="
        w-[42px]
        px-2
        py-2.5
        text-center

        sm:w-[62px]
        sm:px-3.5
        sm:py-3.5
      "
    >
      <span
        className={`
          inline-flex
          h-[27px]
          w-[27px]
          items-center
          justify-center
          rounded-[8px]
          border
          text-[9px]
          font-black
          transition-all
          duration-200

          sm:h-[34px]
          sm:w-[34px]
          sm:rounded-[10px]
          sm:text-xs

          ${
            isSelected
              ? `
                border-[#FFD700]/70
                bg-gradient-to-br
                from-[#FFD700]
                to-[#FF8A00]
                text-black
                shadow-[0_0_18px_rgba(255,184,0,.35)]
              `
              : `
                border-[#FFB800]/25
                bg-[#FFB800]/[0.07]
                text-[#FFB800]
                group-hover:border-[#FFB800]/50
                group-hover:bg-[#FFB800]/[0.12]
              `
          }
        `}
      >
        {globalIndex + 1}
      </span>
    </td>

    {/* =================================================
        MƏHSUL
    ================================================== */}

    <td
      className="
        min-w-0
        px-2
        py-2.5

        sm:px-3.5
        sm:py-3.5
      "
    >
      <div className="min-w-0">
        <div
          className={`
            break-words
            text-[10px]
            font-extrabold
            leading-[1.35]
            transition-colors
            duration-200

            sm:text-sm
            sm:leading-5

            ${
              isSelected
                ? "text-[#FFD700]"
                : "text-white group-hover:text-[#FFD700]"
            }
          `}
        >
          {item.title}
        </div>

        <div
          className="
            mt-0.5
            text-[7px]
            font-bold
            uppercase
            tracking-[.5px]
            text-gray-600

            sm:mt-1
            sm:text-[9px]
            sm:tracking-[.8px]
          "
        >
          FreeFire
        </div>
      </div>
    </td>

    {/* =================================================
        QİYMƏT
    ================================================== */}

    <td
      className="
        w-[75px]
        px-1.5
        py-2.5
        text-right

        sm:w-[120px]
        sm:px-3.5
        sm:py-3.5
      "
    >
      <span
        className="
          whitespace-nowrap
          text-[10px]
          font-black
          tracking-wide
          text-[#FFB800]

          sm:text-[15px]
        "
      >
        {item.price} AZN
      </span>
    </td>

    {/* =================================================
        SEÇ
    ================================================== */}

    <td
      className="
        w-[48px]
        px-1
        py-2.5
        text-center

        sm:w-[68px]
        sm:px-3
        sm:py-3.5
      "
    >
      <span
        className={`
          inline-flex
          h-[25px]
          w-[25px]
          items-center
          justify-center
          rounded-[8px]
          border
          transition-all
          duration-200

          sm:h-[30px]
          sm:w-[30px]
          sm:rounded-[9px]

          ${
            isSelected
              ? `
                border-[#FFD700]
                bg-gradient-to-br
                from-[#FFD700]
                to-[#FF8A00]
                shadow-[0_0_20px_rgba(255,184,0,.45)]
              `
              : `
                border-[#231842]
                bg-[#0D081D]
                group-hover:border-[#FFB800]/50
                group-hover:bg-[#171125]
              `
          }
        `}
      >
        {isSelected && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            className="
              h-3
              w-3
              text-black

              sm:h-4
              sm:w-4
            "
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m5 12 4 4L19 6"
            />
          </svg>
        )}
      </span>
    </td>
  </tr>
);

};

// =========================================================
// CATEGORY ROW
// =========================================================

const renderCategoryRow = (
title,
icon = "diamond"
) => {
return (
<tr>
<td
colSpan={4}
className="
border-y
border-[#FFB800]/25
bg-gradient-to-r
from-[#FFB800]/[0.12]
via-[#8B5CF6]/[0.10]
to-[#8B5CF6]/[0.025]
px-2.5
py-2.5

        sm:px-4
        sm:py-3
      "
    >
      <div
        className="
          flex
          items-center
          gap-2.5

          sm:gap-3
        "
      >
        <span
          className="
            flex
            h-7
            w-7
            shrink-0
            items-center
            justify-center
            rounded-[9px]
            border
            border-[#FFD700]/30
            bg-gradient-to-br
            from-[#FFD700]
            to-[#FF8A00]
            text-black
            shadow-[0_0_18px_rgba(255,184,0,.20)]

            sm:h-8
            sm:w-8
            sm:rounded-[10px]
          "
        >
          {icon === "calendar" ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="h-4 w-4 sm:h-[18px] sm:w-[18px]"
            >
              <rect
                width="18"
                height="18"
                x="3"
                y="4"
                rx="2"
              />
              <path
                strokeLinecap="round"
                d="M16 2v4M8 2v4M3 10h18"
              />
              <path
                strokeLinecap="round"
                d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="h-4 w-4 sm:h-[18px] sm:w-[18px]"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 2 15 8l6 1-4.5 4.5L17.5 20 12 17l-5.5 3 1-6.5L3 9l6-1 3-6Z"
              />
            </svg>
          )}
        </span>

        <div className="min-w-0">
          <div
            className="
              text-[10px]
              font-black
              uppercase
              tracking-[.65px]
              text-[#FFD700]

              sm:text-xs
              sm:tracking-[1px]
            "
          >
            {title}
          </div>

          <div
            className="
              mt-0.5
              text-[7px]
              font-bold
              uppercase
              tracking-[.45px]
              text-gray-500

              sm:text-[9px]
              sm:tracking-[.8px]
            "
          >
            Paketlər
          </div>
        </div>
      </div>
    </td>
  </tr>
);

};

// =========================================================
// UI
// =========================================================

return (
<div
className="
min-h-screen
overflow-x-hidden
bg-gray-50
text-gray-900
transition-colors
duration-300

    dark:bg-[#040209]
    dark:text-gray-100
  "
>
  {/* =====================================================
      BACKGROUND EFFECTS
  ====================================================== */}

  <div
    className="
      pointer-events-none
      fixed
      -left-32
      -top-32
      z-0
      hidden
      h-[500px]
      w-[500px]
      rounded-full
      bg-purple-500/10
      blur-[160px]

      dark:bg-[#8B5CF6]/20

      md:block
    "
  />

  <div
    className="
      pointer-events-none
      fixed
      -right-32
      top-1/2
      z-0
      hidden
      h-[500px]
      w-[500px]
      rounded-full
      bg-cyan-500/10
      blur-[180px]

      dark:bg-[#06B6D4]/15

      md:block
    "
  />

  <div
    className="
      pointer-events-none
      fixed
      -bottom-32
      left-1/3
      z-0
      hidden
      h-[600px]
      w-[600px]
      rounded-full
      bg-pink-500/10
      blur-[200px]

      dark:bg-[#EC4899]/15

      md:block
    "
  />

  {/* Cyber Grid */}

  <div
    className="
      pointer-events-none
      fixed
      inset-0
      z-0
      opacity-40

      dark:opacity-100
    "
    style={{
      backgroundImage:
        "linear-gradient(to right, rgba(80,80,80,.07) 1px, transparent 1px), linear-gradient(to bottom, rgba(80,80,80,.07) 1px, transparent 1px)",
      backgroundSize: "40px 40px",
    }}
  />

  {/* =====================================================
      MAIN
  ====================================================== */}

  <main
    className="
      relative
      z-10
      mx-auto
      flex
      min-h-screen
      w-full
      max-w-7xl
      flex-grow
      flex-col
      gap-6
      px-3
      py-5
      pb-32

      sm:gap-10
      sm:px-5
      sm:py-8
      sm:pb-36

      lg:px-8
      lg:py-10
    "
  >
    {/* ===================================================
        BANNER
    ==================================================== */}

    <section
      className="
        group
        relative
        overflow-hidden
        rounded-2xl
        border
        border-gray-200
        bg-white
        shadow-[0_10px_35px_rgba(0,0,0,.08)]

        dark:border-[#8B5CF6]/50
        dark:bg-[#0D081D]
        dark:shadow-[0_0_35px_rgba(139,92,246,.3)]

        sm:rounded-3xl
      "
    >
      <a
        href="https://wa.me/994506758477"
        target="_blank"
        rel="noopener noreferrer"
        className="relative block"
      >
        <img
          src={FreeFireimg}
          alt="FreeFire"
          className="
            h-auto
            w-full
            max-h-[300px]
            object-cover
            transition
            duration-700
            group-hover:scale-[1.02]

            sm:max-h-[380px]

            lg:max-h-[460px]
          "
        />

        <div
          className="
            pointer-events-none
            absolute
            inset-0
            bg-gradient-to-t
            from-black/30
            via-transparent
            to-transparent
            opacity-80

            dark:from-[#040209]
          "
        />
      </a>
    </section>

    {/* ===================================================
        YOUTUBE
    ==================================================== */}

    <section
      className="
        relative
        mx-auto
        aspect-video
        w-full
        max-w-4xl
        overflow-hidden
        rounded-2xl
        border
        border-gray-200
        bg-white
        shadow-[0_10px_35px_rgba(0,0,0,.08)]

        dark:border-[#231842]
        dark:bg-[#0D081D]
        dark:shadow-[0_0_35px_rgba(139,92,246,.3)]

        sm:rounded-3xl
      "
    >
      <iframe
        className="h-full w-full"
        src="https://www.youtube.com/embed/hGLqd3qfyQs?rel=0&modestbranding=1"
        title="FreeFire Video"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </section>

    {/* ===================================================
        PRODUCTS
    ==================================================== */}

    <section
      className="
        relative
        overflow-hidden
        rounded-2xl
        border
        border-gray-200
        bg-white
        p-3.5
        shadow-[0_10px_35px_rgba(0,0,0,.08)]

        dark:border-[#231842]
        dark:bg-[#0D081D]/80
        dark:shadow-[0_20px_50px_rgba(0,0,0,.6)]

        sm:rounded-3xl
        sm:p-6

        lg:p-10
      "
    >
      {/* =================================================
          WARNING
      ================================================== */}

      <div
        className="
          relative
          z-10
          mb-5
          flex
          items-start
          gap-2.5
          rounded-xl
          border
          border-rose-200
          bg-rose-50
          p-3
          text-[12px]
          text-rose-700

          dark:border-rose-500/30
          dark:bg-rose-950/20
          dark:text-rose-200/90

          sm:mb-8
          sm:gap-3.5
          sm:rounded-2xl
          sm:p-5
          sm:text-xs
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="
            mt-0.5
            h-5
            w-5
            shrink-0
            text-rose-400
          "
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v4m0 4h.01M10.3 3.6 2.5 17a2 2 0 0 0 1.73 3h15.54a2 2 0 0 0 1.73-3L13.7 3.6a2 2 0 0 0-3.4 0Z"
          />
        </svg>

        <p className="leading-relaxed">
          3-cü şəxslərdən və ya oğurluq pullardan
          istifadə edilərsə, Azərbaycan Respublikası
          qanunvericiliyinə uyğun olaraq məsuliyyət
          daşıyırsınız. 16 yaşdan aşağı şəxslərin
          ödəniş etməsinə icazə verilmir.
        </p>
      </div>

      <div
        className="
          pointer-events-none
          absolute
          -right-24
          -top-24
          h-72
          w-72
          rounded-full
          bg-[#FFB800]/5
          blur-3xl

          dark:bg-[#FFB800]/10
        "
      />

      {/* =================================================
          PRODUCT TABLE
      ================================================== */}

      <div
        className="
          relative
          z-10
          mt-5
          w-full

          sm:mt-8
        "
      >
        {loading ? (
          <div
            className="
              flex
              min-h-[250px]
              items-center
              justify-center
              rounded-xl
              border
              border-gray-200
              bg-gray-50

              dark:border-[#231842]
              dark:bg-[#040209]/80
            "
          >
            <div className="flex flex-col items-center">
              <div
                className="
                  mb-4
                  h-10
                  w-10
                  animate-spin
                  rounded-full
                  border-4
                  border-[#231842]
                  border-t-[#FFB800]
                "
              />

              <p className="font-medium text-gray-400">
                Məhsullar yüklənir...
              </p>
            </div>
          </div>
        ) : productError ? (
          <div
            className="
              rounded-xl
              border
              border-rose-200
              bg-rose-50
              py-10
              text-center
              text-[10px]
              font-bold
              text-rose-600

              dark:border-rose-500/30
              dark:bg-rose-950/20
              dark:text-rose-400

              sm:text-xs
            "
          >
            <p>{productError}</p>

            <button
              type="button"
              onClick={getProducts}
              className="
                mt-5
                rounded-xl
                bg-[#FFB800]
                px-5
                py-2.5
                text-sm
                font-black
                text-black
                transition
                hover:bg-[#FF9900]
              "
            >
              Yenidən yoxla
            </button>
          </div>
        ) : products.length === 0 ? (
          <div
            className="
              rounded-xl
              border
              border-gray-200
              bg-gray-50
              py-10
              text-center
              text-[10px]
              font-semibold
              text-gray-500

              dark:border-[#231842]
              dark:bg-[#040209]/70
              dark:text-gray-400

              sm:text-xs
            "
          >
            Məhsul tapılmadı.
          </div>
        ) : (
          <div
            className="
              w-full
              overflow-visible
              rounded-[18px]
              border
              border-[#231842]
              bg-[#040209]
              shadow-[0_20px_50px_rgba(0,0,0,.35)]
            "
          >
            <table
              className="
                w-full
                min-w-0
                table-fixed
                border-collapse
                text-left
              "
            >
              <thead>
                <tr
                  className="
                    border-b
                    border-[#231842]
                    bg-gradient-to-br
                    from-[#171125]
                    to-[#251b3b]
                  "
                >
                  <th
                    className="
                      w-[42px]
                      px-2
                      py-3
                      text-center
                      text-[8px]
                      font-black
                      uppercase
                      tracking-[.5px]
                      text-gray-300

                      sm:w-[62px]
                      sm:px-3.5
                      sm:py-[15px]
                      sm:text-[11px]
                      sm:tracking-[.65px]
                    "
                  >
                    #
                  </th>

                  <th
                    className="
                      px-2
                      py-3
                      text-left
                      text-[8px]
                      font-black
                      uppercase
                      tracking-[.5px]
                      text-gray-300

                      sm:px-3.5
                      sm:py-[15px]
                      sm:text-[11px]
                      sm:tracking-[.65px]
                    "
                  >
                    Məhsul
                  </th>

                  <th
                    className="
                      w-[75px]
                      px-1.5
                      py-3
                      text-right
                      text-[8px]
                      font-black
                      uppercase
                      tracking-[.5px]
                      text-gray-300

                      sm:w-[120px]
                      sm:px-3.5
                      sm:py-[15px]
                      sm:text-[11px]
                      sm:tracking-[.65px]
                    "
                  >
                    Qiymət
                  </th>

                  <th
                    className="
                      w-[48px]
                      px-1
                      py-3
                      text-center
                      text-[8px]
                      font-black
                      uppercase
                      tracking-[.5px]
                      text-gray-300

                      sm:w-[68px]
                      sm:py-[15px]
                      sm:text-[11px]
                      sm:tracking-[.65px]
                    "
                  >
                    Seç
                  </th>
                </tr>
              </thead>

              <tbody>
                {/* =================================================
                    FREEFIRE PAKETİ
                ================================================== */}

                {almazProducts.length > 0 && (
                  <>
                    {renderCategoryRow(
                      "FreeFire paketləri",
                      "diamond"
                    )}

                    {almazProducts.map(
                      (item, index) =>
                        renderProductRow(
                          item,
                          index,
                          index
                        )
                    )}
                  </>
                )}

                {/* =================================================
                    AYLIQ FREEFIRE
                ================================================== */}

                {monthlyProducts.length > 0 && (
                  <>
                    {renderCategoryRow(
                      "Aylıq FreeFire paketləri",
                      "calendar"
                    )}

                    {monthlyProducts.map(
                      (item, index) =>
                        renderProductRow(
                          item,
                          index,
                          almazProducts.length +
                            index
                        )
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* =================================================
          FIXED ORDER CONTROL
      ================================================== */}

      <div
        className="
          fixed
          bottom-0
          left-0
          right-0
          z-[900]
          border-t
          border-gray-200
          bg-white/95
          px-2.5
          py-2.5
          shadow-[0_-8px_30px_rgba(0,0,0,.12)]
          backdrop-blur-xl

          dark:border-[#231842]
          dark:bg-[#080510]/95
          dark:shadow-[0_-8px_35px_rgba(0,0,0,.55)]

          sm:px-4
          sm:py-3
        "
      >
        <div
          className="
            mx-auto
            flex
            w-full
            max-w-7xl
            items-center
            gap-2
          "
        >
          {/* TOTAL */}

          <div
            className="
              flex
              min-w-0
              flex-1
              items-center
              rounded-xl
              border
              border-gray-200
              bg-gray-50
              px-3
              py-2.5

              dark:border-[#231842]
              dark:bg-[#0D081D]

              sm:px-4
              sm:py-3
            "
          >
            <div
              className="
                min-w-0
                flex-1
                overflow-hidden
              "
            >
              <div
                className="
                  text-[9px]
                  font-black
                  uppercase
                  tracking-[.35px]
                  text-gray-500

                  dark:text-gray-500

                  sm:text-[11px]
                  sm:tracking-[.7px]
                "
              >
                Seçilənlər
              </div>

              <div
                className="
                  mt-0.5
                  whitespace-nowrap
                  text-[10px]
                  font-bold
                  text-gray-700

                  dark:text-gray-300

                  sm:text-xs
                "
              >
                {selectedCount} məhsul
              </div>
            </div>

            <div
              className="
                ml-2
                shrink-0
                whitespace-nowrap
                text-[13px]
                font-black
                text-amber-500

                dark:text-amber-400

                sm:ml-4
                sm:text-xl
              "
            >
              {finalTotal.toFixed(2)} AZN
            </div>
          </div>

          {/* ORDER */}

          <button
            type="button"
            onClick={openMultiModal}
            disabled={
              selectedProducts.length === 0
            }
            className="
              inline-flex
              min-h-[47px]
              shrink-0
              items-center
              justify-center
              gap-1.5
              rounded-xl
              border
              border-yellow-300
              bg-gradient-to-br
              from-yellow-300
              via-amber-500
              to-orange-500
              px-3
              text-[9px]
              font-black
              tracking-[.15px]
              text-[#08050b]
              shadow-[0_8px_25px_rgba(255,184,0,.22)]
              transition-all
              duration-200

              hover:-translate-y-0.5
              hover:brightness-110

              disabled:cursor-not-allowed
              disabled:border-gray-300
              disabled:bg-gray-300
              disabled:from-gray-300
              disabled:via-gray-300
              disabled:to-gray-400
              disabled:text-gray-500
              disabled:shadow-none
              disabled:hover:translate-y-0

              sm:min-h-[58px]
              sm:min-w-[260px]
              sm:gap-2.5
              sm:px-6
              sm:text-[12px]
              sm:tracking-[.5px]
            "
          >
            <span
              className="
                text-base

                sm:text-lg
              "
            >
              🛒
            </span>

            <span className="whitespace-nowrap">
              SİFARİŞİ TƏSDİQLƏ
            </span>
          </button>
        </div>
      </div>
    </section>
  </main>

  {/* =====================================================
      MODAL BACKDROP
  ====================================================== */}

  {isModalOpen && (
    <div
      className="
        fixed
        inset-0
        z-[999999999999999999]
        bg-black/70

        dark:bg-[#020108]/90

        md:backdrop-blur-md
      "
      onClick={closeModal}
    />
  )}

  {/* =====================================================
      ORDER MODAL
  ====================================================== */}

  {isModalOpen && (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="order-modal-title"
      className="
        fixed
        left-1/2
        top-1/2
        z-[999999999999999999]
        flex
        max-h-[calc(100dvh-16px)]
        w-[calc(100vw-16px)]
        max-w-[560px]
        -translate-x-1/2
        -translate-y-1/2
        flex-col
        overflow-hidden
        rounded-[18px]
        border
        border-purple-300
        bg-white
        shadow-[0_30px_100px_rgba(0,0,0,.45)]

        dark:border-[#8B5CF6]/45
        dark:bg-gradient-to-br
        dark:from-[#120a25]
        dark:via-[#090612]
        dark:to-[#06040b]
        dark:shadow-[0_30px_100px_rgba(0,0,0,.75),0_0_45px_rgba(139,92,246,.20)]

        sm:w-[calc(100vw-20px)]
        sm:rounded-[28px]

        md:max-h-[90dvh]
      "
      onClick={(event) =>
        event.stopPropagation()
      }
    >
      {/* Modal Header */}

      <div
        className="
          flex
          shrink-0
          items-center
          justify-between
          border-b
          border-gray-200
          px-4
          py-4

          dark:border-white/10
          dark:bg-gradient-to-r
          dark:from-[#8B5CF6]/[0.18]
          dark:via-[#FFB800]/[0.08]
          dark:to-transparent

          sm:px-5
        "
      >
        <h3
          id="order-modal-title"
          className="
            flex
            items-center
            gap-2
            text-sm
            font-black
            tracking-wide
            text-gray-900

            dark:text-white

            sm:text-lg
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className="
              h-5
              w-5
              text-[#FFB800]
            "
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7l-5-5Z"
            />

            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M14 2v6h6M8 13h8M8 17h5"
            />
          </svg>

          Sifariş Məlumatları
        </h3>

        <button
          type="button"
          disabled={submitting}
          onClick={closeModal}
          className="
            flex
            h-9
            w-9
            items-center
            justify-center
            rounded-full
            bg-gray-100
            text-gray-500
            transition

            dark:bg-white/5
            dark:text-gray-400

            hover:bg-gray-200
            hover:text-gray-900

            dark:hover:bg-white/10
            dark:hover:text-white

            disabled:cursor-not-allowed
            disabled:opacity-50
          "
        >
          ✕
        </button>
      </div>

      {/* Modal Form */}

      <form
        onSubmit={handleSubmit}
        className="
          flex-1
          overflow-y-auto
          overscroll-contain
          p-3.5
          text-sm
          text-gray-600

          dark:text-gray-300

          sm:p-5
        "
      >
        <div className="space-y-4">
          {/* Selected packages */}

          <div>
            <label
              className="
                mb-1.5
                block
                text-[10px]
                font-bold
                uppercase
                text-gray-500

                dark:text-gray-400

                sm:text-xs
              "
            >
              Seçilmiş Paketlər
            </label>

            <input
              type="text"
              readOnly
              value={selectedProducts
                .map(
                  (product) =>
                    product.title
                )
                .join(" + ")}
              className="
                min-h-[48px]
                w-full
                rounded-[14px]
                border
                border-gray-200
                bg-gray-50
                p-3
                font-semibold
                text-gray-900
                outline-none

                dark:border-white/10
                dark:bg-[#040209]/80
                dark:text-white
              "
            />
          </div>

          {/* Paket sayı + miqdar */}

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label
                className="
                  mb-1.5
                  block
                  text-[10px]
                  font-bold
                  uppercase
                  text-gray-500

                  dark:text-gray-400

                  sm:text-xs
                "
              >
                Paket Sayı
              </label>

              <input
                type="text"
                readOnly
                value={`${selectedProducts.length} paket`}
                className="
                  min-h-[48px]
                  w-full
                  rounded-[14px]
                  border
                  border-gray-200
                  bg-gray-50
                  p-3
                  font-semibold
                  text-gray-900
                  outline-none

                  dark:border-white/10
                  dark:bg-[#040209]/80
                  dark:text-white
                "
              />
            </div>

            <div>
              <label
                className="
                  mb-1.5
                  block
                  text-[10px]
                  font-bold
                  uppercase
                  text-gray-500

                  dark:text-gray-400

                  sm:text-xs
                "
              >
                Miqdar (X)
              </label>

              <input
                type="number"
                min="1"
                value={count}
                onChange={(event) => {
                  const value =
                    parseInt(
                      event.target.value,
                      10
                    ) || 1;

                  setCount(
                    Math.max(value, 1)
                  );
                }}
                className="
                  min-h-[48px]
                  w-full
                  rounded-[14px]
                  border
                  border-[#FFB800]/60
                  bg-gray-50
                  p-3
                  font-black
                  text-gray-900
                  outline-none
                  transition

                  dark:bg-[#040209]/80
                  dark:text-white

                  focus:border-[#FFB800]
                  focus:ring-2
                  focus:ring-[#FFB800]/10
                "
              />
            </div>
          </div>

          {/* Yekun */}

          <div>
            <label
              className="
                mb-1.5
                block
                text-[10px]
                font-bold
                uppercase
                text-gray-500

                dark:text-gray-400

                sm:text-xs
              "
            >
              Yekun Qiymət
            </label>

            <input
              type="text"
              readOnly
              value={`${finalTotal.toFixed(
                2
              )} AZN`}
              className="
                min-h-[48px]
                w-full
                rounded-[14px]
                border
                border-gray-200
                bg-gray-50
                p-3
                text-lg
                font-black
                text-[#FFB800]
                outline-none

                dark:border-white/10
                dark:bg-[#040209]/80

                sm:text-xl
              "
            />
          </div>

          {/* User ID */}

          <div>
            <label
              className="
                mb-1.5
                block
                text-[10px]
                font-bold
                uppercase
                text-gray-500

                dark:text-gray-400

                sm:text-xs
              "
            >
              FreeFire User ID{" "}
              <span className="text-rose-500">
                *
              </span>
            </label>

            <input
              type="text"
              required
              value={userId}
              onChange={(event) =>
                setUserId(
                  event.target.value
                )
              }
              placeholder="İD nömrənizi daxil edin"
              className="
                min-h-[48px]
                w-full
                rounded-[14px]
                border
                border-gray-200
                bg-gray-50
                p-3
                text-gray-900
                outline-none
                transition
                placeholder:text-gray-400

                dark:border-white/10
                dark:bg-[#040209]/80
                dark:text-white
                dark:placeholder:text-gray-600

                focus:border-[#FFB800]
              "
            />
          </div>

          {/* İş saatı */}

          <div
            className="
              flex
              items-center
              gap-2
              rounded-xl
              border
              border-amber-500/20
              bg-amber-50
              p-3
              text-[10px]
              font-semibold
              text-amber-700

              dark:bg-amber-500/10
              dark:text-amber-300

              sm:text-xs
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="
                h-5
                w-5
                shrink-0
              "
            >
              <circle
                cx="12"
                cy="12"
                r="9"
              />

              <path
                strokeLinecap="round"
                d="M12 7v5l3 2"
              />
            </svg>

            ⏱ İŞ SAATIMIZ: 11:00 - 04:30
          </div>

          {/* Kart */}

          <div
            className="
              relative
              overflow-hidden
              rounded-[18px]
              border
              border-[#FFB800]/25
              bg-gradient-to-br
              from-purple-50
              via-amber-50
              to-gray-50
              p-3.5

              dark:from-[#8B5CF6]/[0.16]
              dark:via-[#FFB800]/[0.08]
              dark:to-[#040209]/80

              sm:p-4
            "
          >
            <span
              className="
                block
                text-[10px]
                font-extrabold
                uppercase
                tracking-widest
                text-gray-400
              "
            >
              Bank Ödəniş Hesabı
            </span>

            <p
              className="
                mt-2
                break-all
                select-all
                font-mono
                text-base
                font-black
                tracking-wider
                text-[#FFB800]

                sm:text-lg
              "
            >
              {kartInfo}
            </p>

            <div
              className="
                pointer-events-none
                absolute
                -right-12
                -top-14
                h-[120px]
                w-[120px]
                rounded-full
                bg-[#FFB800]/[0.13]
                blur-xl
              "
            />
          </div>

          {/* Receipt */}

          <div>
            <label
              className="
                mb-1.5
                block
                text-[10px]
                font-bold
                uppercase
                text-gray-500

                dark:text-gray-400

                sm:text-xs
              "
            >
              Ödəniş Qəbzi (Çek)
            </label>

            <div
              className="
                flex
                w-full
                flex-col
                items-stretch
                gap-3
                rounded-2xl
                border
                border-dashed
                border-[#FFB800]/35
                bg-gray-50
                p-2.5

                dark:bg-white/[0.025]

                sm:flex-row
                sm:items-center
                sm:p-3
              "
            >
              <label
                htmlFor="upload-photo"
                className="
                  flex
                  cursor-pointer
                  items-center
                  justify-center
                  gap-2
                  rounded-xl
                  border
                  border-gray-200
                  bg-purple-100
                  px-4
                  py-2.5
                  text-[10px]
                  font-bold
                  text-gray-900
                  transition

                  dark:border-white/10
                  dark:bg-[#231842]/80
                  dark:text-white

                  sm:text-xs

                  hover:bg-[#231842]
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="
                    h-5
                    w-5
                    text-[#FFB800]
                  "
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 16V4m0 0L8 8m4-4 4 4M5 20h14"
                  />
                </svg>

                Qəbzi Seçin
              </label>

              <input
                id="upload-photo"
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handlePhotoChange}
              />

              <span
                className="
                  truncate
                  text-center
                  text-xs
                  italic
                  text-gray-400

                  sm:text-left
                "
              >
                {uploadStatus}
              </span>
            </div>
          </div>

          {/* Actions */}

          <div
            className="
              grid
              grid-cols-[1fr_1.25fr]
              gap-2.5
              border-t
              border-gray-200
              pt-3

              dark:border-[#231842]

              sm:pt-4
            "
          >
            <button
              type="button"
              disabled={submitting}
              onClick={closeModal}
              className="
                min-h-[50px]
                rounded-[14px]
                border
                border-gray-200
                px-5
                py-3
                text-[10px]
                font-bold
                text-gray-600
                transition

                dark:border-[#231842]
                dark:text-gray-300

                sm:text-xs

                hover:bg-white/5

                disabled:cursor-not-allowed
                disabled:opacity-50
              "
            >
              İmtina
            </button>

            <button
              type="submit"
              disabled={submitting}
              className="
                min-h-[50px]
                rounded-[14px]
                bg-[#FFB800]
                px-7
                py-3
                text-xs
                font-black
                uppercase
                text-black
                shadow-[0_0_25px_rgba(255,184,0,.25)]
                transition

                hover:bg-[#FF9900]

                disabled:cursor-not-allowed
                disabled:opacity-60
              "
            >
              {submitting ? (
                <span
                  className="
                    flex
                    items-center
                    justify-center
                    gap-2
                  "
                >
                  <span
                    className="
                      h-4
                      w-4
                      animate-spin
                      rounded-full
                      border-2
                      border-black/30
                      border-t-black
                    "
                  />

                  GÖNDƏRİLİR...
                </span>
              ) : (
                "GÖNDƏR"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  )}
</div>

);
};

export default FreeFire;